export enum BroadcastRequestSource {
    DepartureBoard,
}

export interface BroadcastMessageData {
    existingMessageId?: string;
    flightTeamIds: string[];
    title: string | null;
    content: string | null;
    requestSource: BroadcastRequestSource;
}
